"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomHash = exports.RandomHash = void 0;
class RandomHash {
    constructor() {
        this.chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    }
    create(length = 34) {
        let hash = '';
        for (let i = 0; i < length; i++) {
            hash += this.chars.charAt(Math.floor(Math.random() * this.chars.length));
        }
        return hash;
    }
}
exports.RandomHash = RandomHash;
const randomHash = (length = 16) => new RandomHash().create(length);
exports.randomHash = randomHash;
